document.addEventListener('DOMContentLoaded', () => {
  const mediaContainer = document.querySelector('.hdt-product-media__layout-2_columns');
  if (!mediaContainer) return;

  const mediaSlides = mediaContainer.querySelectorAll('.hdt-slider__slide');
  const maxVisible = 4;

  // Evitar crear el botón y lógica en mobile (no bloquear slider)
  if (window.matchMedia('(max-width: 768px)').matches) {
    return;
  }

  if (mediaSlides.length <= maxVisible) return;

  let expanded = false;

  const updateSlides = () => {
    mediaSlides.forEach((slide, index) => {
      if (!expanded && index >= maxVisible) {
        slide.classList.add('is-hidden');
      } else {
        slide.classList.remove('is-hidden');
      }
    });

    button.textContent = expanded ? 'Mostrar menos' : 'Mostrar más';
    button.setAttribute('aria-expanded', String(expanded));

    // Recalcula layout del slider
    window.dispatchEvent(new Event('resize'));
  };

  // Crear botón
  const mediaContainer_id = 'wpd-media-slides';
  mediaContainer.id = mediaContainer_id;

  const buttonWrapper = document.createElement('div');
  buttonWrapper.className = 'ver-mas-media';

  const button = document.createElement('button');
  button.type = 'button';
  button.textContent = 'Mostrar más';
  button.setAttribute('aria-expanded', 'false');
  button.setAttribute('aria-controls', mediaContainer_id);

  buttonWrapper.appendChild(button);
  mediaContainer.after(buttonWrapper);

  // Estado inicial (después de crear el botón)
  updateSlides();

  // Click
  button.addEventListener('click', () => {
    expanded = !expanded;
    updateSlides();

    if (!expanded) {
      mediaContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});